module.exports = "/_next/static/images/ea838223404357cc0cfe64ddeeaf3867-rewards-smiles@1x.png";